export default __webpack_public_path__ + "static/media/product-screen-uk.35be5a20.png";